import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import FrankImage from "@/components/frank/FrankImage";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section className="container mx-auto px-4 py-16 md:py-24">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A237E] leading-tight">
            {t('home.hero.title')}
          </h1>
          <p className="text-lg text-[#0061A8] max-w-md">
            {t('home.hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              onClick={() => navigate('/auth')}
              className="bg-[#1A237E] hover:bg-[#673AB7] text-white px-8 py-3 text-lg"
            >
              {t('home.hero.demo_button')}
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-[#2F80ED] text-[#2F80ED] hover:bg-[#2F80ED] hover:text-white px-8 py-3 text-lg"
            >
              {t('home.hero.learn_more')}
            </Button>
          </div>
        </div>
        <FrankImage />
      </div>
    </section>
  );
};

export default HeroSection;